// Détection du navigateur INTÉGRÉ (webview) d'une appli tierce : appli de scan
// de QR code, Instagram, Facebook… (A12, 06/10/2026).
//
// Reprise de let-it-smile/web/camera-aide.mjs (CTO Let it Smile, branche
// develop, commit 68f107a, retour patient du 5 oct.) : MARQUES, estIOS et
// navigateurIntegre copiés tels quels, tests repris dans integre.test.js.
// Ajouts Animax : plateforme(), marque() pour GA4, urlDeSortie().
//
// Pourquoi chez Animax : ces webviews effacent souvent le stockage à la
// fermeture => uid anonyme perdu => collection de l'enfant perdue ; et la
// caméra y est souvent refusée (Scanner). Module PUR (aucun DOM).

// Navigateurs intégrés connus. Android WebView signe « ; wv) » ; les autres apps ajoutent leur
// marque. Sur iOS, un WKWebView n'a pas le jeton « Safari/ » que Safari, Chrome iOS (CriOS),
// Firefox iOS (FxiOS) et Edge iOS (EdgiOS) portent tous.
const MARQUES = /FBAN|FBAV|FB_IAB|Instagram|Line\/|MicroMessenger|Snapchat|musical_ly|TikTok|Twitter|LinkedInApp|Pinterest|GSA\/|KAKAOTALK|WhatsApp/i;

export function estIOS(ua = "") {
  return /iPhone|iPad|iPod/i.test(ua);
}

export function navigateurIntegre(ua = "") {
  if (!ua) return false;
  if (MARQUES.test(ua)) return true;
  if (/Android/i.test(ua) && /; wv\)/.test(ua)) return true;
  if (estIOS(ua) && /AppleWebKit/i.test(ua) && !/Safari\//i.test(ua)) return true;
  return false;
}

export function plateforme(ua = "") {
  if (estIOS(ua)) return "ios";
  if (/Android/i.test(ua)) return "android";
  return "autre";
}

// Marque lisible pour GA4 (dimension « brand »), webview générique sinon.
const NOMS = [
  [/FBAN|FBAV|FB_IAB/i, "facebook"],
  [/Instagram/i, "instagram"],
  [/Line\//i, "line"],
  [/MicroMessenger/i, "wechat"],
  [/Snapchat/i, "snapchat"],
  [/musical_ly|TikTok/i, "tiktok"],
  [/Twitter/i, "twitter"],
  [/LinkedInApp/i, "linkedin"],
  [/Pinterest/i, "pinterest"],
  [/GSA\//i, "google_app"],
  [/KAKAOTALK/i, "kakaotalk"],
  [/WhatsApp/i, "whatsapp"],
];

export function marque(ua = "") {
  for (const [re, nom] of NOMS) if (re.test(ua)) return nom;
  return "webview";
}

// Préfixe de chemin qui marque une arrivée PAR la sortie (anti-boucle côté
// URL ; le drapeau sessionStorage ne survit pas au changement d'appli). Pas de
// paramètre ?… : un id de jeton peut contenir « ? » ou « # » (CLAUDE.md).
export const PREFIXE_SORTIE = "/nav";

// Chemin à rouvrir dans le vrai navigateur. Pour /tk/, l'id complet (« # » et
// « ? » compris, recollés par idDepuisChemin) est ré-encodé en UN segment :
// plus aucun « # » brut, qui couperait aussi l'URL intent:// d'Android.
export function cheminDeSortie({ pathname = "/", search = "", hash = "" }, idJeton = null) {
  if (idJeton) return `${PREFIXE_SORTIE}/tk/${encodeURIComponent(idJeton)}`;
  return `${PREFIXE_SORTIE}${pathname}${search}`;
}

// URL qui demande au système d'ouvrir le vrai navigateur. Android : intent
// vers le navigateur par défaut. iOS : x-safari-https (non documenté, iOS
// récents, pas garanti). Ailleurs : null (pas de tentative).
export function urlDeSortie(ua, host, chemin) {
  const p = plateforme(ua);
  if (p === "android") return `intent://${host}${chemin}#Intent;scheme=https;end`;
  if (p === "ios") return `x-safari-https://${host}${chemin}`;
  return null;
}
